import { useEditorContext } from 'app/state/contexts/EditorContext';
import { MouseEvent } from 'react';
import { Transforms } from 'slate';
import { RenderElementProps, useSlateStatic } from 'slate-react';
import { LinkElement as LinkElementType } from 'slate/types/slate';
import { getBookmarkById } from '../../bookmark';
import { navigateTo } from 'slate/utils';

export const LinkElement = ({ attributes, children, element }: RenderElementProps) => {
  const linkEditor = useSlateStatic();
  const { shadowHost } = useEditorContext();
  const { id, bookmarkId } = element as LinkElementType;
  const { found } = getBookmarkById(linkEditor, bookmarkId ?? '');

  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (found) {
      Transforms.select(linkEditor, found.path);
    }
    navigateTo(shadowHost, bookmarkId ?? '');
  };
  return (
    <a
      {...attributes}
      id={id}
      href={shadowHost ? undefined : `#${bookmarkId}`}
      onClick={(e: MouseEvent<HTMLAnchorElement>) => {
        shadowHost && handleClick(e);
      }}
      className="xrp-link"
    >
      {children}
    </a>
  );
};
